import baseRequest from "../_core/baseRequest";

export default {
    getUserList: params =>
        baseRequest.get(
            `/users?offset=${params.skip}&limit=${params.limit}&activity=${params.activity}&role=${
                params.role
            }${params.searchText ? "&searchText=" + params.searchText : ""}${
                params.excludedRoles ? "&excludedRoles=" + params.excludedRoles : ""
            }`
        ),
    getUser: params => baseRequest.get(`/users/${params.userId}`),
    updateUser: params => baseRequest.put(`/users/${params.user._id}`, params),
    createUser: params => baseRequest.post("/users", params),
    getUserInfo: params => baseRequest.get(`/users/user-info`),
    getAccessibleFields: params => baseRequest.get(`/users/${params.userId}/accessible-fields`),
    updateCommunicationPreferences: params =>
        baseRequest.put(`/users/communication-preferences/${params.userId}`, params.preferences),
    getCommunicationPreferences: params =>
        baseRequest.get(`/users/communication-preferences/${params.userId}`),
    changeUserPassword: params => baseRequest.post("/users/change-company-user-password", params),
    getUserPermissionPolicies: params =>
        baseRequest.get(`users/${params.userId}/permission-policies`),
    getAuthorizedPoolCities: () => baseRequest.get(`users/authorized-pool-cities`),
    getAssignedUserGroups: ({userId, searchText, skip, limit}) =>
        baseRequest.get(
            `users/${userId}/assigned-user-groups?${searchText ? "&searchText=" + searchText : ""}${
                skip ? "&skip=" + skip : ""
            }${limit ? "&limit=" + limit : ""}`
        ),
    assignUserGroup: ({userId, ...params}) =>
        baseRequest.put(`users/${userId}/assign-user-group`, params),
    unassignUserGroup: ({userId, ...params}) =>
        baseRequest.put(`users/${userId}/unassign-user-group`, params),
    getAllowedPermissionPolicies: ({userId, searchText, skip, limit}) =>
        baseRequest.get(
            `users/${userId}/allowed-permission-policies?${
                searchText ? "&searchText=" + searchText : ""
            }${skip ? "&skip=" + skip : ""}${limit ? "&limit=" + limit : ""}`
        ),
    assignAllowedPermissionPolicies: ({userId, ...params}) =>
        baseRequest.put(`users/${userId}/assign-allowed-permission-policies`, params),
    unassignAllowedPermissionPolicy: ({userId, ...params}) =>
        baseRequest.put(`users/${userId}/unassign-allowed-permission-policy`, params),
    getDisallowedPermissionPolicies: ({userId, searchText, skip, limit}) =>
        baseRequest.get(
            `users/${userId}/disallowed-permission-policies?${
                searchText ? "&searchText=" + searchText : ""
            }${skip ? "&skip=" + skip : ""}${limit ? "&limit=" + limit : ""}`
        ),
    assignDisallowedPermissionPolicies: ({userId, ...params}) =>
        baseRequest.put(`users/${userId}/assign-disallowed-permission-policies`, params),
    unassignDisallowedPermissionPolicy: ({userId, ...params}) =>
        baseRequest.put(`users/${userId}/unassign-disallowed-permission-policy`, params),
    getCurrentUsersPermissionPolicies: () => baseRequest.get(`users/permission-policies`),
    getUserCreditStats: ({startDate, endDate, subCompanyId}) => {
        let params = new URLSearchParams();

        if (startDate) {
            params.append("startDate", startDate);
        }
        if (endDate) {
            params.append("endDate", endDate);
        }
        if (subCompanyId) {
            params.append("subCompanyId", subCompanyId);
        }

        return baseRequest.get(`/users/credit-stats?${params.toString()}`);
    },
    bulkUpdateUsers: params => baseRequest.put("/users/bulk-update", params)
};
